import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { createEffect } from '@ngrx/effects';
import { EXCLUDE_ANALYTICS } from '@planone/shared/util-tracking';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { BehaviorSubject, filter, tap } from 'rxjs';
@Injectable()
export class TrackingEffects {
  analyticsExclude$ = createEffect(
    () =>
      this.keycloakService.keycloakEvents$.pipe(
        filter((event) => event.type === KeycloakEventType.OnReady),
        tap(() => {
          const instance = this.keycloakService.getKeycloakInstance();
          if ((instance.tokenParsed?.realm_access?.roles ?? []).includes('excludeAnalytics')) {
            this.excludeAnalytics.next(true);
          }
        })
      ),
    { dispatch: false }
  );

  analyticsExcludeByURLParam$ = createEffect(
    () =>
      this.route.queryParams.pipe(
        filter((params) => Object.keys(params).includes('intern')),
        tap(() => this.excludeAnalytics.next(true))
      ),
    { dispatch: false }
  );

  constructor(
    private keycloakService: KeycloakService,
    private route: ActivatedRoute,
    @Inject(EXCLUDE_ANALYTICS) private excludeAnalytics: BehaviorSubject<boolean>
  ) {}
}
